import React from 'react';
import Information from './Information';
import Transactions from './Transactions';
import Statement from './Statement';

const RenderContent = ({ activeTabMain, vendorData }) => {
	switch (activeTabMain) {
		case 'Information':
			return <Information />;
		case 'Transactions':
			return <Transactions vendor={vendorData} />;
		case 'Statement':
			return <Statement />;
		default:
			return <Information />;
	}
};

export default RenderContent;
